import React from "react";
import { FiSearch, FiGrid, FiList, FiX } from "react-icons/fi";
import OnboardingInput from "../../components/OnboardingComponents/OnboardingInput";
import OnboardingSelect from "../../components/OnboardingComponents/OnboardingSelect";

export type TestFilter = "all" | "test" | "non-test";
export type ViewMode = "grid" | "list";

interface FilterSectionProps {
  searchInput: string;
  setSearchInput: (val: string) => void;
  setPage: (page: number) => void;
  testFilter: TestFilter;
  setTestFilter: (val: TestFilter) => void;
  viewMode: ViewMode;
  setViewMode: (mode: ViewMode) => void;
}

export const FilterSection = ({
  searchInput,
  setSearchInput,
  setPage,
  testFilter,
  setTestFilter,
  viewMode,
  setViewMode,
}: FilterSectionProps) => (
  <div className="mb-8 flex flex-col lg:flex-row lg:items-end justify-between gap-4">
    <div className="w-full lg:flex-1 relative">
      <OnboardingInput
        label="Search Customers"
        placeholder="Search by name, email or customer ID..."
        value={searchInput}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          setSearchInput(e.target.value);
          setPage(1);
        }}
        icon={<FiSearch size={20} className="text-[#A2B2C899]" />}
      />
      {searchInput && (
        <button
          type="button"
          title="Clear search"
          onClick={() => {
            setSearchInput("");
            setPage(1);
          }}
          className="absolute right-4 top-[44px] flex items-center justify-center rounded-full p-1 text-[#A2B2C899] transition hover:bg-[#F3F4F5] hover:text-[#030724]"
        >
          <FiX size={18} />
        </button>
      )}
    </div>

    <div className="flex flex-col sm:flex-row items-end gap-3 z-10 w-full lg:w-auto">
      <div className="w-full sm:w-[220px]">
        <OnboardingSelect
          label="Filter Data"
          value={testFilter}
          onChange={(val: string) => {
            setTestFilter(val as TestFilter);
            setPage(1);
          }}
          options={[
            { value: "all", label: "All Users" },
            { value: "test", label: "Test Data Only" },
            { value: "non-test", label: "Live Data (Non-Test)" },
          ]}
        />
      </div>

      <div className="flex items-center rounded-lg border border-[#A2B2C866] bg-[#F8F9FA] p-1 h-[52px] w-full sm:w-auto">
        <button
          type="button"
          title="Grid view"
          onClick={() => setViewMode("grid")}
          className={`flex flex-1 sm:flex-none h-full items-center justify-center rounded-md px-4 transition-all duration-200 ${
            viewMode === "grid"
              ? "bg-[#1A1F3C] text-white shadow-sm"
              : "text-[#A2B2C899] hover:text-[#1A1F3C] hover:bg-[#F3F4F5]"
          }`}
        >
          <FiGrid size={20} />
        </button>
        <button
          type="button"
          title="List view"
          onClick={() => setViewMode("list")}
          className={`flex flex-1 sm:flex-none h-full items-center justify-center rounded-md px-4 transition-all duration-200 ${
            viewMode === "list"
              ? "bg-[#1A1F3C] text-white shadow-sm"
              : "text-[#A2B2C899] hover:text-[#1A1F3C] hover:bg-[#F3F4F5]"
          }`}
        >
          <FiList size={20} />
        </button>
      </div>
    </div>
  </div>
);